import { ExpandLessOutlined, ExpandMoreOutlined } from "@material-ui/icons";
import React from "react";
import { formatMoney } from "../lib/util";
import { COLORS } from "../pages/theme";
import GroupedUnreconciledCardExpanded from "./grouped_unreconciled_card_expanded";

export default function GroupedUnreconciledCard({
    data,
    expanded_items = [],
    idx,
    expand,
    onReconcile,
    onReconcileAll,
    reference,
    showTransactionModal,
    selectedItems,
    setSelectedItem,
    spinning,
    spinningAll,
}) {
    const expanded = expanded_items.includes(idx);

    const { ours, theirs } = data;

    return (
        <div
            style={{
                width: "100%",
                background: "white",
                marginBottom: 4,
                boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                borderRadius: 4,
                fontSize: 16,
            }}
        >
            <div
                style={{
                    padding: 20,
                    height: 70,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                }}
                onClick={() => expand(idx)}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div style={{ marginRight: 12 }}>
                        <div
                            title={
                                ours[0].type == "C"
                                    ? "Credit"
                                    : ours[0].type == "D"
                                    ? "Debit"
                                    : "N/A"
                            }
                            className={
                                ours[0].type === "D"
                                    ? "debit-circle"
                                    : ours[0].type == "C"
                                    ? "credit-circle"
                                    : "na-circle"
                            }
                            style={{
                                height: 34,
                                width: 34,
                                borderRadius: 18,
                            }}
                        >
                            {ours[0].type}
                        </div>
                    </div>
                    <div style={{ marginRight: 30 }}>
                        <div>{ours[0].txn_date}</div>
                    </div>
                    <div style={{ marginRight: 30 }}>
                        <div>{ours[0].transaction_id}</div>
                    </div>
                    <div style={{ fontWeight: 600 }}>
                        {formatMoney(ours[0].amount)}
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div
                        style={{
                            paddingRight: 15,
                            borderRight: "1px solid #8A8795",
                        }}
                    >
                        <div style={{ color: COLORS.primary }}>
                            {ours.length} txns
                        </div>
                    </div>
                    <div
                        style={{
                            marginLeft: 15,
                            color: COLORS.primary,
                        }}
                    >
                        <div style={{ color: COLORS.primary, marginRight: 30 }}>
                            {theirs.length} txns
                        </div>
                    </div>
                    {!expanded ? (
                        <ExpandMoreOutlined style={{ fill: "#616163" }} />
                    ) : (
                        <ExpandLessOutlined style={{ fill: "#616163" }} />
                    )}
                </div>
            </div>
            {expanded && (
                <GroupedUnreconciledCardExpanded
                    idx={idx}
                    ours={ours}
                    theirs={theirs}
                    reference={reference}
                    onReconcile={onReconcile}
                    onReconcileAll={onReconcileAll}
                    showTransactionModal={showTransactionModal}
                    selectedItems={selectedItems}
                    setSelectedItem={setSelectedItem}
                    spinning={spinning}
                    spinningAll={spinningAll}
                />
            )}
        </div>
    );
}
